import { useQuery } from "@tanstack/react-query";
import { fetchWeekSchedule } from "@/lib/services/staffService";

/**
 * React Query hook for fetching week schedule data as an array of { date, specialistIds } for the week starting at startDate.
 * @param startDate ISO date string (YYYY-MM-DD)
 */
export function useWeekSchedule(startDate: string) {
  return useQuery({
    queryKey: ["weekSchedule", startDate],
    queryFn: () => {
      console.log(`[useWeekSchedule] Fetching week schedule for startDate: ${startDate}`);
      return fetchWeekSchedule(startDate).then((data) => {
        console.log(`[useWeekSchedule] Received week schedule data for ${startDate}:`, data);
        return data;
      });
    },
    enabled: !!startDate,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 60_000, // defensive liveness for passive viewers (doc 07 Phase B)
  });
}
